const upperFirstLetter = (name) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};
export default upperFirstLetter;
